export default "__VITE_PUBLIC_ASSET__8715a660__"